import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  useTheme,
  Paper,
  Button,
  Alert,
} from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { useNavigate, useParams } from "react-router-dom";
import fields from "./fields";
import { useAuth } from "../../../services/auth";
import ModalBox from "../../../ui/ModalBox";
import { useEmployees } from "../Provider";
import EmployeeRole from "./Render/EmployeeRole";
import HourlyRate from "./Render/HourlyRate";
import CustomTable from "../../../ui/CustomTable";
import TabsList from "../../../ui/TabsList";
import SiteCell from "./Render/SiteCell";
import UpdateDate from "./Render/UpdateDate";
import ZonesCell from "./Render/ZonesCell";
import ErrorsList from "../../../ui/ErrorsList";

function BoxInfo({ employee = [] }) {
  const navigate = useNavigate();
  const theme = useTheme();
  const {id} = useParams()

  const [openRateEdit, setOpenRateEdit] = useState(false);
  const { role } = useAuth();
  const {
    state: {
      listSitesEmployees,
      countSites,
      lengthSites,
      pageSites,
      perPageSites,
    },
    remove,
    removeRoleRate,
    removeAllRoles,
    fetchSitesListForEmployee,
    dispatch,
  } = useEmployees();
  const tabs = [{ title: "Sites", num: lengthSites }];

  const [Loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false);
  const [openRate, setOpenRate] = useState(false);
  const [openAddRate, setOpenAddRate] = useState(false);
  const [selectedCols, setSelectedCols] = useState();
  const [index, setIndex] = useState(0);
  const [roleId, setRoleId] = useState("");
  const [rowZone, setRowZone] = useState();
  const [error, setError] = useState();
  const [openDeletAllSites, setOpenDeleteAllSites] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };
  const handleDelete = () => {
    try {
      remove(employee?.id);
      navigate(-1);
    } catch (e) {
      console.log("error", e);
    }
  };
useEffect(() => {
  if (!id) return;
  const load = async () => {
    setLoading(true);
    try {
      await fetchSitesListForEmployee(id, pageSites, perPageSites);
    } finally {
      setLoading(false);
    }
  };
  load();
}, [id, pageSites, perPageSites]);

  const getData = (data) => {
    switch (data) {
      case "companyName":
        return employee?.company?.companyName
          ? employee?.company?.companyName
          : "";
      default:
        break;
    }
  };
  const col = [
    {
      label: "Site Name",
      headTextLeft: true,
      textLeft: true,
      customRender: SiteCell,
    },

    {
      label: "Role",
      customRender: EmployeeRole,
    },
    {
      label: "Hourly Rate",
      name: "hourlyRate",
      customRender: HourlyRate,
      helperText: "not empty",
      checkable: true,
      multiRow: true,
      type: "number",
      number: true,
    },
    {
      label: "Zones",
      customRender: ZonesCell,
      multiRow: true,
    },
    {
      label: "Update Date",
      customRender: UpdateDate,
    },
  ];

  const handleRateClose = () => {
    setOpenRate(false);
  };

  const handleAddRateClose = () => {
    setOpenAddRate(false);
  };
  const handleEditRateClose = () => {
    setOpenRateEdit(false);
    fetchSitesListForEmployee(employee?.id, pageSites, perPageSites);
  };

  const handleDeleteRole = async (ID) => {
    try {
      await removeRoleRate(employee?.id, ID, roleId);
      fetchSitesListForEmployee(employee?.id, pageSites, perPageSites);
    } catch (error) {
      console.log(error);
    }
  };
  const handleDeleteAllSitesClick = async () => {
    try {
      await removeAllRoles(employee?.id, 0);
      fetchSitesListForEmployee(employee?.id, pageSites, perPageSites);
    } catch (error) {
      setError({ title: error?.errors?.message?.toString() });
    }
  };
  const changePageSize = (size) => {
    dispatch({ type: "set_per_page_site", payload: size });
  };
  return (
    <>
      <Paper
        elevation={0}
        sx={{
          p: theme.dimensions.padding,
          mt: theme.dimensions.mt,
          mb: theme.dimensions.mb,
          background: theme.color.PaperbgColor,
          width: "90%",
        }}
      >
        <Grid container>
          <Grid item xs={11} sm={11} md={11}>
            <Typography variant="Poster" component="h4" gutterBottom>
              Employee Information
            </Typography>
            {error && (
              <Alert severity="error" sx={{ m: 3 }}>
                <ErrorsList error={error} />
              </Alert>
            )}
            {employee.photoUrl && (
              <div
                style={{ width: "150px", height: "150px", overflow: "hidden" }}
              >
                <img
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  src={employee?.photoUrl}
                  alt="employeePhoto"
                />
              </div>
            )}
            <Grid container>
              {fields?.map((f, index) => {
                if (f.editOnly) return <></>;
                return (
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    mt={2}
                    key={index}
                    sx={{ fontSize: "14px" }}
                  >
                    <span style={{ color: theme.color.PaperlabelColor }}>
                      {f.label}{" "}
                    </span>
                    <span>
                      {f.fingerprintView ? (
                        <span>
                          {employee?.[f.name]
                            ? "updated at: " + employee?.[f.name]
                            : "not specified"}
                        </span>
                      ) : (
                        employee?.[f?.name] && employee?.[f?.name]
                      )}
                      {getData(f.viewLabel2)}

                      {f.name === "isActive" &&
                        (employee?.isActive ? (
                          <span style={{ color: "#4AA785" }}>
                            <FiberManualRecordIcon
                              fontSize="small"
                              sx={{ fontSize: 10, mr: 0.2 }}
                            />
                            Active
                          </span>
                        ) : (
                          <span style={{ color: "rgba(0, 0, 0, 0.4)" }}>
                            <FiberManualRecordIcon
                              fontSize="small"
                              sx={{ fontSize: 10, mr: 0.2 }}
                            />
                            Inactive
                          </span>
                        ))}
                    </span>
                  </Grid>
                );
              })}
            </Grid>

            {employee?.contractUrl && (
              <Button
                sx={{
                  backgroundColor: theme.color.grayBackground,
                  color: theme.color.dark,
                  "&:hover": { background: `${theme.color.gray50}` },
                }}
              >
                <a
                  style={{ textDecoration: "none", color: theme.color.dark }}
                  href={employee.contractUrl}
                  download
                >
                  Download Contract
                </a>
              </Button>
            )}
          </Grid>
          {employee?.user === null && role !== "Site" && (
            <Grid item>
              <Button
                variant="contained"
                style={{ background: "#FF4747" }}
                onClick={() => setOpen(true)}
              >
                Delete
              </Button>
            </Grid>
          )}
        </Grid>
        <ModalBox
          open={open}
          operation="delete"
          handleClose={handleClose}
          handleOperation={() => {
            handleDelete();
            setOpen(false);
          }}
          text={`Do you want to complete the process of deleting all information?`}
        />
      </Paper>
      <TabsList
        tabs={tabs}
        setSelectedCols={setSelectedCols}
        selectedCols={selectedCols}
      ></TabsList>

      <CustomTable
        empty={listSitesEmployees?.length === 0}
        cols={col}
        data={listSitesEmployees || []}
        actions={
          (role === "Admin" || role === "Company") && {
            hourlyRate: true,
            edit: (e, row) => {
              setOpenRateEdit(true);
              setRowZone(row);
            },
            delete: (e) => handleDeleteRole(e),
          }
        }
        filters={{
          pagination: true,
          page: perPageSites,
          changePageSize: changePageSize,
          add: () => setOpenAddRate(true),
          ...(employee?.sites?.length !== 0 && {
            deleteAllSites: () => setOpenDeleteAllSites(!openDeletAllSites),
          }),
        }}
        showButton={true}
        setIndex={setIndex}
        Index={index}
        isPagination={true}
        roleId={roleId}
        setRoleId={setRoleId}
        count={countSites}
        dispatch={dispatch}
        page={pageSites}
        selectedCols="SitesEmployee"
        Loading={Loading}
      ></CustomTable>
      <ModalBox
        open={openRate}
        operation="edit"
        handleClose={handleRateClose}
        /*         existSite={employee} */
        text="The update operation has been completed successfully.."
        name={`${selectedCols}`}
      />
      <ModalBox
        open={openAddRate}
        addRate={employee?.companyId}
        handleClose={handleAddRateClose}
        text="The update operation has been completed successfully.."
        name={`${selectedCols}`}
        /*         existSite={employee} */
        employee={employee}
      />
      <ModalBox
        open={openRateEdit}
        row={rowZone}
        roleId={roleId}
        setRoleId={setRoleId}
        operation="edit"
        handleClose={handleEditRateClose}
        text="The update operation has been completed successfully.."
        name={`${selectedCols}`}
        editRoleZoneEmp={true}
      />
      <ModalBox
        open={openDeletAllSites}
        operation="delete"
        handleClose={() => {
          setOpenDeleteAllSites(!openDeletAllSites);
        }}
        handleOperation={() => {
          handleDeleteAllSitesClick();
          setOpenDeleteAllSites(false);
        }}
        text={`Do you want to complete the process of deleting all sites?`}
      />
    </>
  );
}

export default BoxInfo;
